export interface GmAppConfig {
  helpUrl: string;
  agreementsLearnMoreUrl: string;
  editPaymentRequestLearnMoreUrl: string;
  agreementSigneeManagerLearnMoreUrl: string;
  walletAppLink: string;
  walletHelpUrl: string;
  orgBudgetsLearnMoreUrl: string;
  userPermissionsLearnMoreUrl: string;
  budgetCategoriesLearnMoreUrl: string;
  contactTeamworksUrl: string;
  personnelPlayerUrl: string;
  paymentRequestTypeHelpUrl: string;
  agentDirectoryLearnMoreUrl: string;
  paths: {
    telemetryPlayerProfile: string;
  };
}

export default <GmAppConfig>{
  helpUrl: 'https://help.teamworks.com/generalmanager/s/',
  agreementsLearnMoreUrl: 'https://help.teamworks.com/generalmanager/s/article/Agreements-And-Contracts',
  editPaymentRequestLearnMoreUrl: 'https://help.teamworks.com/generalmanager/s/article/Payment-Requests',
  agreementSigneeManagerLearnMoreUrl: 'https://help.teamworks.com/generalmanager/s/article/Multi-Signature-Workflows',
  walletAppLink: 'https://twwallet.app.link/redirect',
  walletHelpUrl: 'https://help.teamworks.com/wallet/s/article/Personal-Account-Application-and-Onboarding',
  orgBudgetsLearnMoreUrl: 'https://help.teamworks.com/generalmanager/s/article/Organizational-Budgets-View',
  userPermissionsLearnMoreUrl: 'https://help.teamworks.com/generalmanager/s/article/User-Roles-and-Permissions',
  budgetCategoriesLearnMoreUrl: 'https://help.teamworks.com/generalmanager/s/article/Custom-Budget-Categories',
  contactTeamworksUrl: 'https://teamworks.com/contact/',
  personnelPlayerUrl: 'https://app.telemetry.fm/',
  paymentRequestTypeHelpUrl: 'https://help.teamworks.com/generalmanager/s/article/general-manager-payment-types',
  // Placeholder until the real Agent Directory help article is published; actual route added later.
  agentDirectoryLearnMoreUrl: 'https://help.teamworks.com/generalmanager/s/article/Agent-Directory',
  paths: {
    telemetryPlayerProfile: '/ncaa/player',
  },
};
